class CountdownTimer extends HTMLElement {
    connectedCallback() {
        this.endAttr = this.getAttribute("data-countdown-end");
        this.expiredSetting = this.getAttribute("data-expired-setting") || "remove";
        this.removeScope = this.getAttribute("data-remove-scope") || "element";

        this.valueEls = {
            days: this.querySelector('[data-value="days"]'),
            hours: this.querySelector('[data-value="hours"]'),
            minutes: this.querySelector('[data-value="minutes"]'),
            seconds: this.querySelector('[data-value="seconds"]'),
        };

        this.unitEls = {
            days: this.querySelector('[data-unit="days"]'),
        };

        this.start();
    }

    start() {
        const now = new Date();
        const endDate = this.endAttr ? new Date(this.endAttr) : null;

        if (!endDate || Number.isNaN(endDate.getTime()) || endDate <= now) {
            this.handleExpired(now);
            return;
        }

        this.tick(endDate);
        this.interval = setInterval(() => this.tick(endDate), 1000);
    }

    handleExpired(now) {
        if (this.expiredSetting === "midnight") {
            const midnight = new Date(now);
            midnight.setHours(23, 59, 59, 999);

            if (midnight > now) {
                this.tick(midnight);
                this.interval = setInterval(() => this.tick(midnight), 1000);
                return;
            }
        }

        this.removeByScope();
    }

    tick(endDate) {
        const diffMs = endDate - new Date();

        if (diffMs <= 0) {
            clearInterval(this.interval);
            this.handleExpired(new Date());
            return;
        }

        const totalSeconds = Math.floor(diffMs / 1000);

        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        this.setUnit("days", days, { pad: false });
        this.setUnit("hours", hours, { pad: true });
        this.setUnit("minutes", minutes, { pad: true });
        this.setUnit("seconds", seconds, { pad: true });

        // Days conditional visibility
        if (this.unitEls.days) this.unitEls.days.classList.toggle('hidden', days <= 0)

    }

    setUnit(name, value, opts = {}) {
        const el = this.valueEls[name];
        if (!el) return;

        const str = opts.pad ? String(value).padStart(2, "0") : String(value);
        el.textContent = str;
    }

    removeByScope() {
        clearInterval(this.interval);

        if (this.removeScope === "parent") {
            const wrapper = this.closest("[data-countdown-wrapper]");
            if (wrapper) {
                wrapper.remove();
                return;
            }
        }

        this.remove();
    }

    disconnectedCallback() {
        clearInterval(this.interval);
    }
}

customElements.define("countdown-timer", CountdownTimer);
